import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSiteWorkoutPagesHidden } from "@/features/accountNavV5/lib/useSiteWorkoutPagesHidden";
import { HiddenWorkoutPage, hiddenWorkoutPageTarget } from "@/features/accountNavV5/model/siteWorkoutPages";

/*
 * Календарь (/account/workouts), план (/account/plan-create) и загрузка файла
 * с часов (/account/fit-upload) — только в приложении (владелец, 03.10;
 * рубильник SITE_WORKOUT_PAGES_HIDDEN).
 *
 * Кому они скрыты, тому прямой адрес открывает «Тренировки» — карточку
 * приложения с тестовой тренировкой — с заменой записи истории: «Назад» не
 * возвращает на скрытый адрес, а старые ссылки (покупка, советы лиги,
 * достижения, туры, закладки) не умирают. Переход, а не карточка на месте:
 * горит тот пункт меню и та вкладка, чей это экран.
 *
 * В окне приложения (?source=app) открыта одна загрузка файла — это решает
 * сам useSiteWorkoutPagesHidden по `page`: кнопка «Загрузить тренировку»
 * приложения v5 открывает именно /account/fit-upload сайта
 * (APP_WINDOW_KEEPS_FIT_UPLOAD).
 */
export const SiteWorkoutPageGate: React.FC<{ page: HiddenWorkoutPage; children: React.ReactNode }> = ({
    page,
    children,
}) => {
    const { lang } = useParams<{ lang: string }>();
    const { hidden, pending } = useSiteWorkoutPagesHidden(page);
    if (pending) return <div data-site-workout-gate={page} aria-busy="true" />;
    if (hidden) return <Navigate replace to={hiddenWorkoutPageTarget(lang)} />;
    return <>{children}</>;
};

export default SiteWorkoutPageGate;
